import styled from 'styled-components'

const ModulesStyled = styled.div`
  .modules-wrapper {
    padding: 50px 0;
  }
`

export default ModulesStyled
